import { createFileRoute } from '@tanstack/react-router'
import AcceptInviteForm from "@/components/auth/AcceptInviteForm";

function AcceptInvite() {
  return <AcceptInviteForm />;
}

export const Route = createFileRoute('/(authentication)/(auth)/accept-invite/')({
  component: AcceptInvite,
})
